/* global */
// **************************************************
// Match Height
// **************************************************

if (windowWidth() > breakpointMd) {
  const matchHeight = (resize) => {
    const elements = document.querySelectorAll('.faq__item-title');
    const allHeights = [];
    let i = 0;
    if (resize === true) {
      for (i = 0; i < elements.length; i += 1) {
        elements[i].style.height = 'auto';
      }
    }
    for (i = 0; i < elements.length; i += 1) {
      const elementHeight = elements[i].clientHeight;
      allHeights.push(elementHeight);
    }
    for (i = 0; i < elements.length; i += 1) {
      // eslint-disable-next-line prefer-spread
      elements[i].style.height = `${Math.max.apply(Math, allHeights)}px`;
    }
  };

  window.addEventListener('load', () => {
    matchHeight(false);
  });
  window.addEventListener('resize', () => {
    matchHeight(true);
  });
}
